/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : index.js
 * DESCRIPTION    : Router 주소 설정 파일
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

import { createRouter, createWebHistory } from 'vue-router'
import AttendeeReplay from '../views/AttendeeReplay.vue'

import Error400 from '../error/Error400.vue'
import Error401 from '../error/Error401.vue'
import Error403 from '../error/Error403.vue'
import Error404 from '../error/Error404.vue'
import Error500 from '../error/Error500.vue'
import NonePermission from '../error/NonePermission.vue'

const routes = [
  {
    path: '/',
    redirect: '/error/403',
  },

  {
    path:'/attendMeetReply/:_PARAM',
    name: 'attendMeetReply',
    component: AttendeeReplay,
    props: true,
  },




  {
    path: '/error/403',
    name: 'Error403',
    component: Error403
  },
  {
    path: '/error/400',
    name: 'Error400',
    component: Error400
  },
  {
    path: '/error/404',
    name: 'Error404',
    component: Error404
  },
  {
    path: '/error/500',
    name: 'Error500',
    component: Error500
  },
  {
    path: '/error/nonePermission',
    name: 'NonePermission',
    component: NonePermission
  },  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: "hash",

  routes
})

export default router
